module.exports = __webpack_public_path__ + "static/media/pic2.ca499d9e.jpg";